const SESSION_KEY = "bs_access_token";
const SESSION_NAME_KEY = "bs_access_name";

export function getSession(): { token: string; name: string } | null {
  const token = localStorage.getItem(SESSION_KEY);
  const name = localStorage.getItem(SESSION_NAME_KEY);
  if (!token) return null;
  return { token, name: name || "" };
}

export function setSession(token: string, name: string): void {
  localStorage.setItem(SESSION_KEY, token);
  localStorage.setItem(SESSION_NAME_KEY, name);
}

export function clearSession(): void {
  localStorage.removeItem(SESSION_KEY);
  localStorage.removeItem(SESSION_NAME_KEY);
}

export function isAuthenticated(): boolean {
  return !!localStorage.getItem(SESSION_KEY);
}
